<template>
  <div>
    <!-- Adviseurs omgeving; Details adviseur -->
    <div v-if="Number(role) === 2">
      <div id="firstMenubar" class="row roundedtop menubar">
        <div class="title">Tools</div>
        <a
          v-if="style == 'db'"
          href="https://www.doelbeleggen.nl/agenda/atp"
          target="_blank"
          class="button"
          style="float:right;"
        >
          <awesomeIcon icon="phone-alt"/>
          <span class="mobile-hidden"> Plan een belafspraak in</span>
        </a>
      </div>
      <div class="card inset-small marginbottom" v-if="Number(role) == 2">
        <h3>Samen Doelbeleggen - dé portal voor adviserend Nederland</h3>
        <p>
          U bent in het 'tools' scherm waar u een overzicht heeft van onze tools.
        </p>
      </div>
    </div>
    <div class="flex-container">
      <div
        class="flex-33 card option"
        @click="doAction('jaarruimte')"
        style="height: 200px;"
      >
        <awesomeIcon style="float:right" icon="external-link-alt" />
        <h2>Jaarruimte berekenen</h2>
        <p>
          Klik hier om onze jaarruimte bereken tool te gebruiken. Let op, je wordt doorverwezen naar
          www.doelbeleggen.nl.
        </p>
      </div>

      <div
        class="flex-33 card fakeOption"
        style="height: 200px;"
      >
        <h2>Binnenkort meer tools</h2>
        <p>
          Er wordt hard gewerkt aan nieuwe tools. Zodra deze beschikbaar zijn, worden deze hier
          getoond.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'atpTools',
  data() {
    return {
      style: process.env.VUE_APP_STYLE,
    };
  },
  computed: {
    role() {
      return this.$store.state.role;
    },
  },
  methods: {
    doAction(action) {
      if (action === 'jaarruimte') {
        window.open(
          'https://www.doelbeleggen.nl/samen-doelbeleggen/tools/jaarruimte-berekenen/',
          '_blank',
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-container {
  column-gap: 20px;
  row-gap: 20px;
  @media #{$mobile} {
    row-gap: 10px;
    padding: 43px 10px 10px;
  }
}
.fakeOption {
  text-align: left;
  overflow: hidden;
  background: #e9ecf2;
  border-radius: $br;
  padding: 20px;
  color: $color-background;
}
@media #{$mobile} {
  #firstMenubar {
    top: 91px !important;
  }
}
</style>
